import React from "react";

import { ArticleGalleryItem, galleryItemOrigin } from "@/mk2/apps/wiki/gallery";
import { wikiArticleUrl } from "@/mk2/apps/wiki/utils";
import { Link } from "@/mk2/components/Link";
import { WikiArticleEntity } from "@/mk2/schemas";
import { interpolate } from "@/mk2/services/i18n";
import {
    WIKI_PHOTO_FROM_REVIEW_BY_nick,
    WIKI_PHOTO_ORIGIN_MANUFACTURER,
    WIKI_PHOTO_SHOW_REVIEW,
} from "@/mk/autogenerated/translations/GalleryPhotoOrigin.78755d69dd48a097d2aa14e87f0b00e8";

import styles from "./GalleryPhotoOrigin.mscss";

interface Props {
    article: WikiArticleEntity;
    item: ArticleGalleryItem;
}

// Lightbox overlay for a single photo: top-left tells its origin (manufacturer photo
// vs. a photo from a review by a given reviewer), top-right links back to that review.
export const GalleryPhotoOrigin: React.FunctionComponent<Props> = ({ article, item }) => {
    const origin = galleryItemOrigin(article, item);

    return (
        <>
            <div className={styles.GalleryPhotoOrigin__label}>
                {origin.isReviewArticlePhotoGalleryItem
                    ? WIKI_PHOTO_ORIGIN_MANUFACTURER
                    : interpolate(WIKI_PHOTO_FROM_REVIEW_BY_nick, { nick: origin.nick ?? "" })}
            </div>
            {!origin.isReviewArticlePhotoGalleryItem && origin.experienceId != null && origin.nick && (
                <Link
                    className={styles.GalleryPhotoOrigin__reviewLink}
                    to={wikiArticleUrl(article, `experience-${origin.experienceId}`)}
                >
                    {WIKI_PHOTO_SHOW_REVIEW}
                </Link>
            )}
        </>
    );
};
